import { apiClient } from '@/app/network/apiClient';

export async function deleteUserByEmail(email: string): Promise<void> {
  await apiClient.post<void>(
    '/v1/dev/delete-user-by-email',
    { email: email.trim() },
    { anonymous: true },
  );
}
